module.exports = { id: "man-frame", url: "/build/app/img/symbols.svg#man-frame", viewBox: "", toString: function() { return this.url; } };